// Same like in colors.scss
const baseColors = Object.freeze({
  'orange-1': '#fff7e6', // --color-orange-1
  'orange-6': '#fa8c16', // --color-orange-6

  'cyan-7': '#08979c', // --color-cyan-7

  'volcano-1': '#fff2e8', // --color-volcano-1

  'gray-5': '#d9d9d9',

  'green-1': '#f6ffed', // --color-green-1
  'green-3': '#b7eb8f', // --color-green-3
  'green-6': '#52C41A', // --color-green-6

  'purple-1': '#f9f0ff', // --color-purple-1
  'purple-3': '#d3adf7', // --color-purple-3
  'purple-5': '#9254de', // --color-purple-5;
  'purple-6': '#722ed1', // --color-purple-6;

  'red-1': '#fff1f0', // --color-red-1
  'red-3': '#ffa39e', // --color-red-3
  'red-4': '#FF7875', // --color-red-4
  'red-5': '#FF4D4F', // --color-red-5
  'red-6': '#F5222D', // --color-red-6

  'ibm-carbon-blue-1': '#edf5ff',
  'ibm-carbon-blue-3': '#a6c8ff',
  'ibm-carbon-blue-5': '#4589ff',
  'ibm-carbon-blue-6': '#0f62fe',
});

const defaultColors = Object.freeze({
  default: 'rgba(0, 0, 0, 0.85)',
  secondary: 'rgba(0, 0, 0, 0.45)',

  'background-light': 'rgba(0, 0, 0, 0.02)',
  'background-disaled': 'rgba(0, 0, 0, 0.04)',

  'icon-default': '#979797',
  disabled: 'rgba(0, 0, 0, 0.25)',
});

const colors = Object.freeze({
  baseColors,
  defaultColors,

  black: '#000000',
  white: '#FFFFFF',

  default: 'rgba(0, 0, 0, 0.85)',
  secondary: 'rgba(0, 0, 0, 0.45)',
  success: '#52C41A', // --color-green-6
  warning: '#FAAD14', // --color-gold-6

  main1: '#22BDFF', // '#0F62FE', // --color-ibm-carbon-blue-6
  main2: '#4589FF', // --color-ibm-carbon-blue-5
  main3: '#0043CE', // --color-ibm-carbon-blue-7

  dangerLight: baseColors['red-4'],
  dangerMedium: baseColors['red-5'],
  dangerHeavy: baseColors['red-6'],

  backgroundLight: 'rgba(0, 0, 0, 0.02)',
  backgroundDisabled: 'rgba(0, 0, 0, 0.04)',
  border: 'rgba(0, 0, 0, 0.15)',

  customTableHeader: 'rgba(5, 5, 5, 0.06)',
  borderInfoTable: 'rgba(0, 0, 0, 0.06)',

  selectedTableRow: baseColors['ibm-carbon-blue-1'],

  icon: {
    default: defaultColors['icon-default'],
    disabled: defaultColors.disabled,
  },

  presale: {
    background: {
      critical: baseColors['red-1'],
      unusual: baseColors['purple-1'],
    },
    border: {
      critical: baseColors['red-3'],
      unusual: baseColors['purple-5'],
    },
    text: {
      critical: baseColors['red-6'],
      unusual: baseColors['purple-6'],
    },

    customer: {
      background: {
        idle: defaultColors['background-light'],
        success: baseColors['green-1'],
        warning: baseColors['orange-1'],
        critical: baseColors['red-1'],
        unusual: baseColors['purple-1'],
      },
      icon: {
        idle: defaultColors.secondary,
        success: baseColors['green-6'],
        warning: baseColors['orange-6'],
        critical: baseColors['red-6'],
        unusual: baseColors['purple-5'],
      },
      border: {
        critical: baseColors['red-3'],
        unusual: baseColors['purple-3'],
      },
    },

    vendor: {
      background: {
        idle: defaultColors['background-light'],
        success: baseColors['green-1'],
        warning: baseColors['orange-1'],
        critical: baseColors['red-1'],
        unusual: baseColors['purple-1'],
      },
      icon: {
        idle: defaultColors.secondary,
        success: baseColors['green-6'],
        warning: baseColors['orange-6'],
        critical: baseColors['red-6'],
        unusual: baseColors['purple-5'],
      },
      border: {
        critical: baseColors['red-3'],
        unusual: baseColors['purple-3'],
        success: baseColors['green-3'],
      },
    },

    freight: {
      background: {
        idle: defaultColors['background-light'],
        neutral: baseColors['ibm-carbon-blue-1'],
        success: baseColors['green-1'],
        warning: baseColors['orange-1'],
        critical: baseColors['red-1'],
        unusual: baseColors['purple-1'],
      },
      icon: {
        idle: defaultColors.secondary,
        neutral: baseColors['ibm-carbon-blue-6'],
        success: baseColors['green-6'],
        warning: baseColors['orange-6'],
        critical: baseColors['red-6'],
        unusual: baseColors['purple-5'],
      },
      border: {
        critical: baseColors['red-3'],
      },
    },
  },
});

export default colors;
